import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    withCredentials: true
});

// This function will be called by the AuthProvider to set up the interceptor
export const setupAuthInterceptor = (logoutUser : any) => {
    api.interceptors.response.use(
        (response) => response, // Pass through successful responses
        (error) => {
     
            if (error.response && error.response.status === 401) {
                logoutUser(); 
                // Optionally redirect to login page
                // window.location.href = '/login';
            }
            return Promise.reject(error);
        }
    );
};

export default api;